// Startup timestamps, all as epoch ms (plus performance.now() where the JS
// side took them). Process start comes from the native layer.

export const STARTUP_ORDER = ['processStart', 'jsEntry', 'gameBundleEvaluated', 'firebaseReady', 'authDone', 'docRead', 'firstWarFrame']

export function createStartupMarks(timeOrigin) {
    const marks = {}
    return {
        marks,
        mark(name, perfMs) {
            if (marks[name]) return marks[name]
            marks[name] = { perfMs, epochMs: timeOrigin + perfMs }
            return marks[name]
        },
        setEpoch(name, epochMs, source) {
            marks[name] = { perfMs: epochMs - timeOrigin, epochMs, source }
        },
    }
}

// The required marks in STARTUP_ORDER order. Returns the problems, if any.
export function checkStartupOrder(marks) {
    const problems = []
    let prev = null
    for (const name of STARTUP_ORDER) {
        const m = marks[name]
        if (!m) { problems.push(`missing ${name}`); continue }
        if (prev && m.epochMs < marks[prev].epochMs) problems.push(`${name} before ${prev}`)
        prev = name
    }
    return problems
}

// Each mark as ms since process start.
export function sinceProcessStart(marks) {
    const t0 = marks.processStart?.epochMs
    if (t0 == null) return {}
    return Object.fromEntries(Object.entries(marks).map(([k, v]) => [k, Math.round((v.epochMs - t0) * 10) / 10]))
}
